import "./currencyCard.scss";
import React, { useEffect, useState } from "react";

import chart from "../../assets/images/icons/chart.svg";
import ChartModal from "../ChartModal";

const CurrencyCard = ({ currency }) => {
  // flag import
  const flagSvg = require(`../../assets/images/icons/flags/1x1/${currency?.currency.symbol}.svg`);

  const { REACT_APP_URL } = process.env;

  // states
  const [modalOpen, setModalOpen] = useState(false);
  const [buyPrices, setBuyPrices] = useState([]);
  const [sellPrices, setSellPrices] = useState([]);
  const [archive, setArchive] = useState([]);

  useEffect(() => {
    fetch(`${REACT_APP_URL}/api/currency-archive`, {
      method: "POST",
      headers: {
        "Content-type": "application/json",
      },
      body: JSON.stringify({
        currencyId: currency?.id,
      }),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        // Extract buyPrices and sellPrices into separate arrays
        setArchive(data.data.map((item) => item.createdAt));
        setBuyPrices(data.data.map((item) => parseFloat(item.buyPrice)));
        setSellPrices(data.data.map((item) => parseFloat(item.sellPrice)));
      })
      .catch((err) => console.log(err));
  }, []);

  // handlers
  const openModal = () => setModalOpen(true);
  const closeModal = () => setModalOpen(false);

  return (
    <div className={`currency-card-container`}>
      <div className="currency-info">
        <div className="currency-name">
          <div className="flag">
            <img src={flagSvg} alt={currency?.currency.symbol} />
          </div>
          <div className="name">
            <div>{currency?.currency.name}</div>
            <div>{currency?.currency.symbol}</div>
          </div>
        </div>
        <div className="chart">
          <img
            src={chart}
            alt={currency?.currency.symbol}
            onClick={(e) => {
              e.preventDefault();
              openModal();
            }}
          />
          <ChartModal
            isOpen={modalOpen}
            onClose={closeModal}
            buyPrices={buyPrices}
            sellPrices={sellPrices}
            name={currency?.currency.name}
            archive={archive}
          />
        </div>
      </div>
      <div className="price">
        <div className="price-item">
          <span>فروش: </span>
          <span className="num">{currency?.sellPrice.toLocaleString()} </span>
        </div>
        <div className="price-item">
          <span>خرید: </span>
          <span className="num">{currency?.buyPrice.toLocaleString()} </span>
        </div>
      </div>
    </div>
  );
};

export default CurrencyCard;
